import Promise from 'bluebird';
import axios from 'axios';
import {signin as signinApi, signup as signupApi, validateAccessToken as validateApi} from '../apis/account';
import {updateProfile} from "../apis/updateProfile";
import {setRuntimeVariable, setPersistentVariable, clearPersistentVariables} from "./variable";
import Swal from "sweetalert2";
import {review as reviewApi} from "../apis/review";


export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
// export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
// export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

function requestLogin(creds) {
    return {
        type: LOGIN_REQUEST,
        isFetching: true,
        isAuthenticated: false
    };
}

export function receiveLogin(user, tokens) {
    return {
        type: LOGIN_SUCCESS,
        isAuthenticated: true,
        user: user,
        tokens: tokens,
    };
}

function loginError(message) {
    return {
        type: LOGIN_FAILURE,
        isFetching: false,
        isAuthenticated: false,
        message: message,
    };
}
//
// function requestLogout() {
//     return {
//         type: LOGOUT_REQUEST,
//         isFetching: true,
//         isAuthenticated: true,
//     };
// }

export function logout() {
    return {
        type: LOGOUT_SUCCESS,
        isAuthenticated: false,
    };
}


export function signup(payload) {

    return async (dispatch) => {

        let result = await signupApi(payload);
        // console.log("user signup result", result);

        return result;
    }
    };


export function refreshUserData() {
    return async (dispatch) => {
        console.log("Refresh user data");
        // dispatch(getNotification())
    }
};

export function validate(user, tokens) {
    return async (dispatch) => {
        let result = await validateApi(tokens.access);

        if (result.status==="success") {
            dispatch(receiveLogin(user, tokens));
            // dispatch(connect(user.id, user.firstName, tokens.chat));
            dispatch(refreshUserData());
        } else
        {
            dispatch(clearPersistentVariables());
            dispatch(logout());
        }
    }
};

export function signin(creds) {

    return async (dispatch) => {

        let result = await signinApi(creds);
        // console.log(result);

        if (result.status==="Success" && result.user) {
            // console.log("result", result);
            result.tokens = {
                "access" : result.token
            };

            dispatch(setPersistentVariable({name: "user", value: result.user}));
            dispatch(setPersistentVariable({name: "tokens", value: result.tokens})); // store token to local storage

            // dispatch(connect(result.user.id, result.user.firstName, result.tokens.chat));

            dispatch(receiveLogin(result.user, result.tokens)); //assign token to axios
            dispatch(refreshUserData());

            // axios.defaults.headers.common['Authorization'] = result.tokens;
        } else
        {
        }

        return result;

        // dispatch(requestLogin(creds));
        //
        // return axios.post(process.env.API_URL + `/users/signin`, {
        //     email: creds.username,
        //     password: creds.password,
        // })
        //     .then(res => {
        //         if (res.data.status === 'success') {
        //             localStorage.setItem('TOKEN', res.data.token);
        //             localStorage.setItem('USER', JSON.stringify(res.data.user));
        //             console.log(res.data);
        //             axios.defaults.headers.common['Authorization'] = res.data.accessToken;
        //             dispatch(saveAuthToken(res.data.user, res.data.accessToken));
        //             dispatch(receiveLogin(res.data.user, res.data.accessToken));
        //
        //             if (window.LogRocket) {
        //                 window.LogRocket.identify(res.data.user.id, {
        //                     name: res.data.user.firstName + ' ' + res.data.user.lastName,
        //                     email: res.data.user.email,
        //
        //                     // Add your own custom user variables here, ie:
        //                     // subscriptionType: 'pro'
        //                 });
        //             }
        //
        //             refreshUserData(dispatch);
        //
        //             return Promise.resolve(res.data.user);
        //         } else
        //         {
        //             dispatch(loginError(res.data.message));
        //             return Promise.reject(new Error(res.data.message));
        //         }
        //     })
        //     .catch((error) => {
        //         dispatch(loginError(error.message));
        //         return Promise.reject(new Error(error.message));
        //     });
    };
}

export function signout() {
    return (dispatch) => {
        dispatch(logout());
        dispatch(clearPersistentVariables());
    };
}

export function subscribe(payload) {
    return (dispatch) => {
        return axios.post(process.env.API_URL + `/users/subscribe`, payload)
            .then(res => {
                console.log(res.data);
                if (res.data.status === 'success') {
                    return Promise.resolve(res.data);
                } else
                {
                    return Promise.reject(new Error(res.data.message));
                }
            })
            .catch((error) => {
                return Promise.reject(new Error(error.message));
            });
    };
}

export function getUniverse() {
    return (dispatch) => {
        return axios.post(process.env.API_URL + `/users/universe/detail`, {})
            .then(res => {
                // console.log(res.data);
                if (res.data.status === 'success') {
                    return Promise.resolve(res.data.detail);
                } else
                {
                    return Promise.reject(new Error(res.data.message));
                }
            })
            .catch((error) => {
                return Promise.reject(new Error(error.message));
            });
    };
}

export function updateUniverse(payload) {
    return (dispatch) => {
        return axios.post(process.env.API_URL + `/users/universe/update`, payload)
            .then(res => {
                // console.log(res.data);
                if (res.data.status === 'success') {
                    return Promise.resolve();
                } else
                {
                    return Promise.reject(new Error(res.data.message));
                }
            })
            .catch((error) => {
                return Promise.reject(new Error(error.message));
            });
    };
}

//update photoUrl and about me page from edit
export function editProfile(payload){
    return async (dispatch) => {
        let result = await updateProfile(payload);
        // console.log("user edit result", result);
        return result;
    }
};

